import "./App.css";
import Approute from "./approuter";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AlertContext } from "./context/context";
import { Alert } from "./components";
import { useAlert } from "./hooks/useAlert";
import { baseUrl } from "./api";
import axios from 'axios'

function App() {
  const { alertState, setAlertState, closeAlert } = useAlert();

  axios.defaults.headers = {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  }
  axios.defaults.baseURL = baseUrl;

  return (
    <div className="App">
      {alertState.show && (
        <div className="d-flex align-items-center justify-content-center px-3">
          <Alert {...alertState} onClick={closeAlert} />
        </div>
      )}
      <ToastContainer
        position="top-right"
        theme="dark"
        hideProgressBar={true}
        autoClose={5000}
      />
      <AlertContext.Provider value={{ alertState, setAlertState }}>
        <Approute />
      </AlertContext.Provider>
    </div>
  );
}

export default App;